const USER_ROUTES = {
  getUser: 'user',
}

export default USER_ROUTES
